import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

export const useResources = () => {
  const { t } = useTranslation();

  const [resources, setResources] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [titleCategory, setTitleCategory] = useState(null);
  const [cardSelected, setCardSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Estados para feedback visual (Snackbar)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const filterResourcesByCategory = async (categoryId, categoryName) => {
    setCardSelected(null);
    setSelectedCategory(categoryId);
    setTitleCategory(categoryName);
    setIsLoading(true);

    try {
      const response = await api.post('resources', {
        categoryId: parseInt(categoryId),
      });
      const data = await response.data;
      setResources(data.resources);
    } catch (err) {
      console.error('Erro ao filtrar recursos:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteResource = async (resourceId) => {
    try {
      await api.delete(`resources/${resourceId}`);
      setResources((prev) => prev.filter((r) => r.id !== resourceId));
      setCardSelected(null);
      setSnackbarSeverity('success');
      setSnackbarMessage(t('resource.deleted_successfully'));
    } catch (error) {
      console.error('Erro ao excluir recurso:', error);
      setSnackbarSeverity('error');
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data?.error?.includes('foreign key constraint')
      ) {
        setSnackbarMessage(t('resource.has_linked_resources'));
      } else {
        setSnackbarMessage(t('resource.delete_erro'));
      }
    } finally {
      setSnackbarOpen(true);
    }
  };

  const clearSelection = () => {
    setSelectedCategory(null);
    setTitleCategory(null);
    setCardSelected(null);
    setResources([]);
  };

  return {
    resources,
    setResources,
    selectedCategory,
    setSelectedCategory,
    titleCategory,
    setTitleCategory,
    cardSelected,
    setCardSelected,
    isLoading,
    filterResourcesByCategory,
    deleteResource,
    clearSelection,
    // Snackbar control
    snackbarMessage,
    snackbarSeverity,
    snackbarOpen,
    setSnackbarOpen,
    setSnackbarMessage,
    setSnackbarSeverity,
  };
};
